import { useRef, useEffect } from 'react';

export function CustomCursor({ enabled = true }) {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  
  useEffect(() => {
    if (!enabled) return;
    
    let mx = 0, my = 0, rx = 0, ry = 0, raf = 0;
    
    const onMove = (e) => {
      mx = e.clientX; 
      my = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${mx}px, ${my}px) translate(-50%,-50%)`;
      }
      if (!raf) raf = requestAnimationFrame(loop);
    };
    
    const loop = () => {
      rx += (mx - rx) * 0.18;
      ry += (my - ry) * 0.18;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${rx}px, ${ry}px) translate(-50%,-50%)`;
      }
      if (Math.abs(mx - rx) > 0.5 || Math.abs(my - ry) > 0.5) {
        raf = requestAnimationFrame(loop);
      } else {
        raf = 0;
      }
    };
    
    const onOver = (e) => {
      const interactive = e.target.closest("a, button, [data-cursor='hover']");
      if (ringRef.current) ringRef.current.classList.toggle("hover", !!interactive);
    };
    
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", onOver);
    
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [enabled]);
  
  if (!enabled) return null;
  
  return (
    <>
      <div className="cursor-ring" ref={ringRef}></div>
      <div className="cursor-dot" ref={dotRef}></div>
    </>
  );
}
